"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsGetCreative = exports.facebookAdsGetCreativeResultSchema = exports.facebookAdsGetCreativeArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsGetCreativeArgsSchema = zod_1.z.object({
    creativeId: zod_1.z.string().describe('Facebook Ad Creative ID to fetch details for'),
    emitMode: zod_1.z.literal('single'),
});
exports.facebookAdsGetCreativeResultSchema = zod_1.z.object({
    creative: zod_1.z.object({
        id: zod_1.z.string().describe('Creative ID'),
        name: zod_1.z.string().nullish().describe('Creative name'),
        title: zod_1.z.string().nullish().describe('Creative title/headline'),
        body: zod_1.z.string().nullish().describe('Creative body text'),
        link_url: zod_1.z.string().nullish().describe('Destination link URL'),
        call_to_action_type: zod_1.z
            .string()
            .nullish()
            .describe('Call to action type (e.g., LEARN_MORE, SHOP_NOW)'),
        image_hash: zod_1.z.string().nullish().describe('Facebook image hash'),
        video_id: zod_1.z.string().nullish().describe('Facebook video ID'),
        thumbnail_url: zod_1.z.string().nullish().describe('Video thumbnail URL'),
    }),
});
exports.facebookAdsGetCreative = (0, common_1.createToolMetadata)({
    id: 'facebookAdsGetCreative',
    displayName: 'Get Facebook Ad Creative',
    displayDescription: 'Get detailed information about a Facebook Ad creative including images, text, and links',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsGetCreativeArgsSchema,
}, exports.facebookAdsGetCreativeResultSchema);
